<script>
export default {
  inheritAttrs: true,
  props: {
    buttonType: {
      type: String,
      default: 'buttonPrimary',
    },
  },
}
</script>

<template>
  <b-button
    :class="$style[buttonType]"
    v-bind="$attrs"
    variant="primary"
    v-on="$listeners"
  >
    <slot />
  </b-button>
</template>

<style lang="scss" module>
@import '@design';

.buttonPrimary {
  @extend %typography-small;

  display: flex;
  justify-content: center;
  min-width: 80px;
  padding: $size-button-padding;
  color: $color-button-text;
  cursor: pointer;
  background: $color-button-primary-bg;
  border: none;
  &:disabled {
    cursor: not-allowed;
    background: $color-button-disabled-bg;
  }

  &:hover {
    background: $color-button-primary-bg-hover;
  }
}

.largeButton {
  @extend %typography-small;

  padding: 18px 40px;
  font-size: 19px;
  color: $color-button-text;
  cursor: pointer;
  background: $color-button-primary-bg;
  border: none;

  &:disabled {
    cursor: not-allowed;
    background: $color-button-disabled-bg;
  }

  &:hover {
    background: $color-button-primary-bg-hover;
  }
}

.buttonPrimarySmall {
  @extend %typography-small;

  color: $color-button-text;
  cursor: pointer;
  background: $color-button-primary-bg;
  border: none;

  &:disabled {
    cursor: not-allowed;
    background: $color-button-disabled-bg;
  }

  &:hover {
    background: $color-button-primary-bg-hover;
  }
}

.buttonSecondary {
  padding: $size-button-padding;
  color: $color-button-text;
  cursor: pointer;
  background: $color-button-secondary-bg;
  border: none;

  &:disabled {
    cursor: not-allowed;
    background: $color-button-disabled-bg;
  }

  &:hover {
    background: $color-button-secondary-bg-hover;
  }
}

.buttonTertiary {
  padding: $size-button-padding;
  color: #004990;
  cursor: pointer;
  background: #dcdcdc;
  border: none;
}
</style>
